'use strict';

var constants = require('../constants.cjs');

const HEADER_KEY_API_ACCESS_TOKEN = "x-flex-aid";
function isRouteChangeCanceledError(error) {
  return error === constants.CustomErrorType.RouteChangeCanceled;
}
function isAccessTokenTypeError(error) {
  return error instanceof TypeError && error.message.includes(HEADER_KEY_API_ACCESS_TOKEN);
}

exports.isAccessTokenTypeError = isAccessTokenTypeError;
exports.isRouteChangeCanceledError = isRouteChangeCanceledError;
//# sourceMappingURL=customError.cjs.map
